import { FillImage } from "components/images";
import { Section } from "components/section";
import React from "react";
import { MediaAccordion } from "ui/accordion";
import { Button } from "ui/button";
import { Link } from "ui/link";
import { TextTitle } from "ui/text";
import accordion1 from "../../../../public/assets/solutions/advertising/activation-accordion-1.png";
import accordion2 from "../../../../public/assets/solutions/advertising/activation-accordion-2.png";
import accordion3 from "../../../../public/assets/solutions/advertising/activation-accordion-3.png";
import accordion4 from "../../../../public/assets/solutions/advertising/activation-accordion-4.png";

export function ActivationFeatures() {
  return (
    <Section>
      <TextTitle
        size="lg"
        align="center"
        title="Activate audiences, experiments, and conversion events in minutes"
        description="Suppress active customers, run win-back and upsell campaigns, and enable advanced bidding strategies."
        descriptionMaxW="2xl"
        actions={
          <Button hasRightChevron href="/platform/composable-cdp">
            The Composable CDP
          </Button>
        }
        mb={{ base: "big", md: "biggest", lg: "huge" }}
      />

      <MediaAccordion
        hasBorder
        variant="dynamic"
        items={[
          {
            title: "Build any audience",
            content:
              "Get audiences directly from your data source to every major walled garden, DSP, CTV platform, and clean room in minutes. Build your audience, select your destination, and go.",
            media: (
              <FillImage
                src={accordion1}
                alt='An illustration demonstrating the process of defining an audience filter named "USA Active Customers" in the Hightouch application. The filter specifies that the property "VIP_CUSTOMER" must equal true, and the user must have performed a "Product viewed" action at least once in the past 7 days.'
              />
            ),
          },
          {
            title: "Reach more users & devices",
            content:
              "Engage more customers across more screens with a cookieless identity graph that maximizes audience reach, enhances conversion quality, and improves campaign performance.",
            media: (
              <FillImage
                src={accordion2}
                alt='An illustration demonstrating the Match Booster feature in Hightouch. With the "Enable match booster" setting turned on, it shows that the "Email", "Phone", "Mobile Ad ID", and "IP Address" identifiers are all being enriched using the cookieless identity graph.'
              />
            ),
          },
          {
            title: "Run better experiments and uncover insights",
            content:
              "Set up, execute, and measure A/B tests, multivariate tests, and hold-out groups with the accuracy of an analytics team — all on your own.",
            media: (
              <FillImage
                src={accordion3}
                alt='An illustration showing a sample experiment with three split groups. One group is a "Holdout group", one group will be receiving "Treatment 1", and the last group will be receiving "Treatment 2".'
              />
            ),
          },
          {
            title: "Send conversion events",
            content: (
              <>
                Easily deploy{" "}
                <Link variant="inlineDark" href="/blog/conversion-apis">
                  Conversion API (CAPI) events
                </Link>{" "}
                without engineering. Unlock value-based optimization and smart bidding with calculated conversion
                values.
              </>
            ),
            media: (
              <FillImage
                src={accordion4}
                alt='An illustration demonstrating the use of Hightouch Copilot. A question that starts with "How much revenue have I earned from my campaigns..." is shown above a line graph with five lines that represent revenue earned per campaign type. A single point is highlighted on one of the lines, with a popover noting this is the "Email Campaign" that has earned "3617" in revenue.'
              />
            ),
          },
        ]}
      />
    </Section>
  );
}
